import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import RadioButtonUncheckedOutlinedIcon from "@mui/icons-material/RadioButtonUncheckedOutlined";
import Tooltip from "../common/Tooltip";

const StepIcon = ({ status }) => {
  if (status === "done") {
    return <CheckCircleOutlineIcon className="privacy-step-icon-done" />;
  }
  if (status === "active") {
    return <span className="privacy-step-spinner" />;
  }
  return <RadioButtonUncheckedOutlinedIcon className="privacy-step-icon-pending" />;
};

const PrivacyStepsProgress = ({ steps }) => (
  <div className="privacy-steps">
    <p className="privacy-steps-title">Privacybescherming actief</p>
    <ul className="privacy-steps-list">
      {steps.map((step) => (
        <li key={step.key} className={`privacy-step privacy-step-${step.status}`}>
          <Tooltip content={step.hint} top="-50px" left="-110px" width="26px">
            <StepIcon status={step.status} />
          </Tooltip>
          <span className="privacy-step-label">{step.label}</span>
        </li>
      ))}
    </ul>
  </div>
);

export default PrivacyStepsProgress;
